export default {
    getDO: state => state.deliveryOrders,
    getMassDoUpdate : state => state.massDeliveryorders,
}
